Alpine.data('invoiceItems', () => ({
    rows: [],

    init() {
        const hidden = document.querySelector('input[name="InvoiceItems"]');
        if (hidden && hidden.value) {
            try {
                const parsed = JSON.parse(hidden.value);
                if (parsed.data) {
                    this.rows = parsed.data
                        .filter(row => row[0] && row[0].content)
                        .map(row => ({
                            title: this.clean(row[0]?.content || ''),
                            amount: this.clean(row[1]?.content || ''),
                            rate: this.clean(row[2]?.content || ''),
                        }));
                }
            } catch (e) {
                // ignore
            }
        }
        if (this.rows.length === 0) {
            this.addRow();
        }
    },

    clean(val) {
        return String(val).replace(/<br\s*\/?>/gi, '').trim();
    },

    addRow() {
        this.rows.push({ title: '', amount: '', rate: '' });
    },

    removeRow(index) {
        this.rows.splice(index, 1);
        this.sync();
    },

    parseNum(val) {
        if (!val) return 0;
        return parseFloat(String(val).replace(',', '.')) || 0;
    },

    rowSum(row) {
        if (String(row.amount).toLowerCase() === 'pauschal') {
            const sum = this.parseNum(row.rate);
            return sum ? sum.toFixed(2).replace('.', ',') + ' €' : '';
        }
        const sum = this.parseNum(row.amount) * this.parseNum(row.rate);
        return sum ? sum.toFixed(2).replace('.', ',') + ' €' : '';
    },

    total() {
        let sum = 0;
        for (const row of this.rows) {
            if (String(row.amount).toLowerCase() === 'pauschal') {
                sum += this.parseNum(row.rate);
            } else {
                sum += this.parseNum(row.amount) * this.parseNum(row.rate);
            }
        }
        return sum.toFixed(2).replace('.', ',') + ' €';
    },

    sync() {
        const data = this.rows.map(row => [
            { content: row.title, format: {} },
            { content: row.amount, format: {} },
            { content: row.rate, format: {} },
            { content: '', format: {} },
        ]);
        const hidden = document.querySelector('input[name="InvoiceItems"]');
        if (hidden) {
            hidden.value = JSON.stringify({
                meta: { rows: data.length, columns: 4 },
                data: data,
            });
        }
    },
}));

// Re-initialize any uninitialised Alpine components (loaded after Alpine.start())
document.querySelectorAll('[x-data]:not([x-data-initialized])').forEach(el => {
    if (!el._x_dataStack) {
        Alpine.initTree(el);
    }
});
